import { Link } from "react-router-dom";

export default function HomeCTA() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20inviting%20digital%20content%20creation%20workspace%20with%20soft%20ambient%20lighting%2C%20creative%20atmosphere%20with%20warm%20orange%20and%20pink%20tones%2C%20modern%20studio%20environment%2C%20comfortable%20and%20aspirational%20setting%2C%20editorial%20photography%2C%20wide%20shot&width=1600&height=600&seq=cta-bg-candy&orientation=landscape"
        alt="糖果直播CTA背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/45 to-black/55"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
          准备好开启你的直播之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
          无论是想了解行业动态、寻找优质栏目，还是学习直播技巧，糖果直播都是你的最佳伙伴。立即开始探索吧！
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/category/shiyong-jiaocheng"
            className="px-8 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始学习
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}